import { useEffect, useRef, useState } from 'react'
import { pick, floor, flatten } from 'lodash-es'
import {
  useCityAmap,
  labelMarkersPlugin,
  boundsPlugin,
  polysPlugin,
  onlyDistrictPlugin,
  Layer,
  iconMap,
} from '@ow/maps/lib'
import { useProjectStore, useTbViewStore } from '@vt/hooks'
import { defaultMapConfig } from './utils'
import jiedao from './cy.json'

const useVtAmap = (mapId) => {
  const chaoyangLayer = {}
  const jiedaoLayer = {}
  const getVtProject = useProjectStore((state) => state.getVtProject)
  const { amapKey = '0e4f7b5e424e7db93755cb5d48e71a75' } = getVtProject()
  const {
    ditto: tbDitto,
    filters,
    mapConfig = defaultMapConfig,
    setLoading,
  } = useTbViewStore((state) =>
    pick(state, ['ditto', 'mapConfig', 'filters', 'setLoading'])
  )

  const [currentData, setCurrentData] = useState([])
  // const [loading, setLoading] = useState(false)
  // const [bounds, setBounds] = useState()

  // const boundsLayer = useRef(new Layer(null, {}))
  const labelMarkerLayer = useRef(new Layer(null, {}))

  const { AMap, getApis, inited, addControl } = useCityAmap(mapId, {
    amapKey,
    plugins: [
      boundsPlugin(),
      labelMarkersPlugin(),
      onlyDistrictPlugin(),
      polysPlugin({ cacheKey: 'id' }),
    ],
    zoom: mapConfig.zoom,
    zooms: mapConfig.zooms,
    center: mapConfig.center,
  })

  // 获取坐标数据
  const loadData = async () => {
    labelMarkerLayer.current.clear()

    // const { initLabelMarker } = getApis()
    // initLabelMarker(labelMarkerLayer.current)

    setLoading(true)
    const total = await tbDitto.fetchTableDataCount({
      filters,
    })

    const pageNum = floor(total / 1000) + 1
    const arr = []
    for (let i = 0; i <= pageNum; i++) {
      arr[i] = i
    }

    Promise.all(
      arr.map((item, index) => {
        return tbDitto.fetchTbData({
          filters,
          pageSize: 1000,
          pageNum: index,
        })
      })
    ).then((res) => {
      setCurrentData(flatten(res))
      setLoading(false)
    })
  }

  useEffect(() => {
    if (inited) {
      const icon = {
        type: 'image',
        image: iconMap['markBlue'],
        size: [20, 20],
      }

      const markerData = []
      currentData.forEach((item, i) => {
        if (item.lnglat && item.lnglat.length > 0) {
          markerData.push({
            ...item,
            position: item.lnglat,
            id: `${item.objectId}-${i}`,
          })
        }
      })

      labelMarkerLayer.current.render(markerData, { icon, autoFit: false })
    }
  }, [currentData])

  useEffect(() => {
    if (inited) {
      const { initLabelMarker, initDistrict, initPolys } = getApis()
      initLabelMarker(labelMarkerLayer.current)
      initDistrict(chaoyangLayer)
      chaoyangLayer.render('朝阳区')
      initPolys(jiedaoLayer)
      jiedaoLayer.render(
        jiedao.features.map((v) => {
          return { path: v.geometry.coordinates[0][0], ...v }
        }),
        {
          type: 'Polygon',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: 'white',
          fillOpacity: 0,
          strokeStyle: 'solid',
          fillColor: '#80d8ff',
          strokeColor: 'red',
        }
      )
      const toolbar = new AMap.current.ToolBar() //创建工具条插件实例
      // toolbar.position = { top: 5, left: 5 }
      addControl(toolbar) //添加工具条插件到页面
      // initBounds(boundsLayer.current, { onChange: setBounds })

      // setBounds(boundsLayer.current.getBounds())
    }
  }, [inited])

  useEffect(() => {
    if (!inited) return
    loadData()
  }, [inited, filters])
}

export default useVtAmap
